module.exports = __webpack_public_path__ + "img/Passbild2undGross.eec70c6d.jpg";